<template>
  <div v-if="model.isShow" :class="['bg-default']">
    <div :class="['w-full', 'bg-orange-300/20 border-b', 'border-orange-300/40', 'shadow-xs']">
      <div :class="['page_view', 'flex items-center gap-2', 'py-2', 'text-default-500']">
        <UIcon v-if="model.icon" :name="model.icon" mode="svg" :class="['lg:size-4 size-4']" />
        <div :class="['flex-1', 'font-semibold']">
          <slot />
        </div>
        <UButton icon="mdi-close" variant="ghost" size="sm" @click="model.isShow = false" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  interface HintProps {
    isShow: boolean
    icon?: string
  }

  const model = defineModel<HintProps>({
    required: true,
  })
</script>
